export default "__VITE_ASSET__sdfnUmfb__"